module.exports = __webpack_public_path__ + "static/img/18b.977b790.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/18b.jpg
// module id = 1OWJ
// module chunks = 0